import Axios from 'axios';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { HeartOutlined, HeartFilled } from '@ant-design/icons';

const BtnLikeStyle = styled.button`
    border: none;
    padding: 0;
    margin-left: auto;
    background: transparent;
    font-size: 20px;

    & + & {
        margin-left: 5px;
    }
`;

function BtnLike({ target }) {
    const user = useSelector(state => state.user);
    const [LikeCnt, setLikeCnt] = useState(target?.likes?.length);
    const [ILikeIt, setILikeIt] = useState(target?.likes?.includes(user?.userData?._id));

    return (
        <BtnLikeStyle onClick={(evt) => {
            console.log('click');
            if (!target) {
                console.log('BtnLike의 target 이 지정되지 않았습니다');
                return;
            }

            evt.preventDefault();
            Axios.put('/api/product/like/' + target._id)
                .then(response => {
                    if (response.data.success) {
                        console.log('success like product');
                        setLikeCnt(response.data.product?.likes?.length);
                        setILikeIt(target?.likes?.includes(user?.userData?._id));
                    } else {
                        console.log('Failed like product');
                    }
                })
                .catch(err => console.log(err));
        }}>
            {ILikeIt ?
                <HeartFilled />
                :
                <HeartOutlined />
            }
            <span style={{ fontSize: '15px' }}>
                {LikeCnt}
            </span>
        </BtnLikeStyle>
    )
}

export default BtnLike